import { PaymentMethod } from 'src/@types/box-office';
import { OrganizerSettingsState } from '../@types/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: OrganizerSettingsState = {
  settingsId: null,
  paymentMethods: [PaymentMethod.CASH, PaymentMethod.CARD],
};

const organizerSettingsSlice = createSlice({
  name: 'organizerSettings',
  initialState,
  reducers: {
    setOrganizerSettings(state: OrganizerSettingsState, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const organizerSettingsActions = organizerSettingsSlice.actions;

export default organizerSettingsSlice.reducer;
